export const Colors = {
  Error: "#E13B30",
  Success: "#219653",
  Yellow: "#E6B558",
  Orenge: "#f57c00",
  Blue: "#005FCC",
  Black: "#000000",
  White: "#ffffff",
};

export const statusTextColor = (params) => {
  return {
    // fontSize: "1rem",
    // borderRadius: 6,
    color: ["in progress", "wc"].includes(params?.row?.status)
      ? Colors.Yellow
      : ["ordered", "refund", "delivery"].includes(params?.row?.status)
      ? Colors.Blue
      : params?.row?.status === "wp"
      ? Colors.Orenge
      : params?.row?.status === "success"
      ? Colors.Success
      : Colors.Error,
  };
};

export const statusOrderColor = (params) => {
  return {
    fontSize: "1rem",
    borderRadius: 6,
    textAlign: "center",
    color: Colors.White,

    backgroundColor: ["in progress", "wc"].includes(params?.status)
      ? Colors.Yellow
      : ["ordered", "refund", "delivery"].includes(params?.status)
      ? Colors.Blue
      : params?.status === "wp"
      ? Colors.Orenge
      : params?.status === "success"
      ? Colors.Success
      : Colors.Error,
    ".MuiSelect-icon": {
      color: Colors.White,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-notchedOutline":
      {
        borderColor: "transparent",
      },
    ".Mui-disabled, &.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      color: Colors.White,
      WebkitTextFillColor: Colors.White,
      borderColor: "transparent",
    },
  };
};

export const caseButtonColor = (params) => {
  return {
    width: "100%",
    padding: "12px 16px",
    borderRadius: "8px",
    color: Colors.White,
    backgroundColor: ["in progress", "wc"].includes(params?.row?.status)
      ? Colors.Yellow
      : ["ordered", "refund", "delivery"].includes(params?.row?.status)
      ? Colors.Blue
      : params?.row?.status === "wp"
      ? Colors.Orenge
      : params?.row?.status === "success"
      ? Colors.Success
      : Colors.Error,
    boxShadow: "none",
    cursor: "default",
    "&:hover": {
      cursor: "default",
      backgroundColor: ["wp", "wc"].includes(params?.row?.status)
        ? Colors.Yellow
        : ["ordered", "refund", "delivery"].includes(params?.row?.status)
        ? Colors.Blue
        : params?.row?.status === "in progress"
        ? Colors.Orenge
        : params?.row?.status === "success"
        ? Colors.Success
        : Colors.Error,
      boxShadow: "none",
    },
  };
};

/**
 *
 * @param {*} hex - Hex color code
 * @param {*} opacity - Opacity value 0 - 1 (optional)
 * @returns RGBA color code
 */
export const hexToRgba = (hex, opacity = 1) => {
  const hexValue = hex.replace("#", "");
  const r = parseInt(hexValue.substring(0, 2), 16);
  const g = parseInt(hexValue.substring(2, 4), 16);
  const b = parseInt(hexValue.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
